import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Scan from '../views/Scan.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/scan',
    name: 'Scan',
    component: Scan
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
